import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {

  constructor(private readonly http: HttpClient) { }

  // Url mudada de upload-file..... para upload-files, qualquer coisa volta no environment
  uploadFile(body: any) {
    return this.http.post(`/apiconnect/file/upload-files`, body);
  }

  consultaEmpresaLogada(cnpjEmpresaLogada: any) {
    const url: string = '/apiconnect/importation/company/' + cnpjEmpresaLogada + `/companies`;

    return this.http.get(url);
  }

  consultaStatusImportacao(cnpj: any, nomeArquivo: string) {
    const urlStatus: string = `/apiconnect/orders/import/last-data/${cnpj}/companies?nomeArquivo=${nomeArquivo}`;

    return this.http.get(urlStatus);
  }

  consultaStatusImportacaoConclusao(idEmpresa: any, idImportacao: string) {
    const urlStatus: string = `/apiconnect/core/upload-progress?idEmpresa=${idEmpresa}&idImportacao=${idImportacao}`;

    return this.http.get(urlStatus);
  }

  consultaErrosImportacao(idImportacao: number) {
    const url: string = `/apiconnect/core/importations/${idImportacao}/errors`;

    return this.http.get(url);
  }

  consultaResumoImportacao(idImportacao: any) {
    const url: string = `/apiconnect/orders/import/summary/${idImportacao}/importations`;

    return this.http.get(url);
  }

  // Consulta última importação, verificar se existe uma importação em andamento
  consultaUltimaImportacao(idEmpresa: any) {
    const url: string = `/apiconnect/orders/import/last-data-imp/${idEmpresa}/companies`;

    return this.http.get(url);
  }

  // Altera o status da importacao para FINALIZADO (Serve para consultar o status da importaacao e ver q foi finalizada)
  finalizaImportacao(idImportacao: number, flagStatus: string) {
    const url: string = `/apiconnect/orders/import/${idImportacao}/importations?flagStatus=${flagStatus}`;

    return this.http.get(url);
  }

  public getDownload ( idImportacao ){
    return this.http.get (`/apiconnect/importation/report/inconsistency/${idImportacao}/importations`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  public getDownloadInconsistencias (idImportacao: any){
    return this.http.get (`/apiconnect/file-summary/imports/${idImportacao}/inconsistencies`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
  consultaRecargaCerta(cnpj_empresa: any){
    return this.http.get(`/apiconnect/orders/right-refill/status/${cnpj_empresa}`)
  }

  consultaCnpjArquivo(cnpjEmpresa: any, nomeArquivo: string){
    return this.http.get(`/apiconnect/core/import-status/${cnpjEmpresa}/company/${nomeArquivo}/file-names`)
  }

  novoArquivo(nomeArquivo: any, idEmpresa: any, tipoArquivo: any, autoAjuste: any, recargaCerta: any, arquivo: any){
   return this.http.get(`/apiconnect/file-new/files/${nomeArquivo}/process?&companyid=${idEmpresa}&filetype=${tipoArquivo}&selftuning=${autoAjuste}&surerecharge=${recargaCerta}`, arquivo)
  }

  recuperarStatusImportacao(idImportacao: any){
    return this.http.get(`/apiconnect/file-summary/imports/${idImportacao}/status`);
  }

  checkImportacao(idEmpresa: any){
    return this.http.get(`/apiconnect/file-summary/imports/companies/${idEmpresa}/last`);
  }

  resumoImportacao(idImportacao: any){
    return this.http.get(`/apiconnect/file-summary/imports/${idImportacao}/summary`);
  }

  concluirImportacao(idImportacao: any){
    return this.http.post(`/apiconnect/file-summary/imports/${idImportacao}/conclude`, {});
  }

  preConclusaoImportacao(idImportacao: any, isDePara: any){
    if (isDePara === true) {
      isDePara = `?to-from-page=true`;
    } else {
      isDePara = '';
    }
    return this.http.get(`/apiconnect/file-summary/imports/${idImportacao}/confirm${isDePara}`);
  }

  consultaDadosBucket(idEmpresa: any){
    return this.http.get(`/apiconnect/orders/calculations/companies/${idEmpresa}/upload`)
  }

  getS3PreSignedUploadUrl(fileName: string): Observable<string> {
    const url = `/apiconnect/file-new/files/${fileName}/upload`;
    return this.http.get(url, { responseType: 'text' });
  }


  uploadFileToS3(s3Url: string, fileSelected: any) {
    return this.http.put('/s3bucket/' + s3Url, fileSelected);
  }

  getStatusConclusaoImportacao(idImportacao: any){
    return this.http.get(`/apiconnect/file-database/imports-data/${idImportacao}/status-conclude`);
  }
}
